import { render, staticRenderFns } from "./enviada.vue?vue&type=template&id=13d0fdc0&"
import script from "./enviada.vue?vue&type=script&lang=js&"
export * from "./enviada.vue?vue&type=script&lang=js&"
import style0 from "./enviada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports